export type Folders = 'posts' | 'toys/models'

export const MIME_EXT_DICTINARY = {
    'image/png': '.png',
    'image/jpeg': '.jpeg',
    'image/jpg': '.jpg',
}

export const MAX_POST_SIZE_IN_MB = 2
